<template>
  <div class="userMenu">
    <FormManagerList ref="form" @sucess="getback()"/>
    <div class="tabs">
      <el-tooltip v-if="$store.state.cachePagesList && $store.state.cachePagesList.length"  effect="dark" content="关闭全部页面" placement="top">
        <i class="el-icon-error closeIcon" @click="clearAllPages"></i>
      </el-tooltip>
      <el-tabs class="tabsBoby" :value="$store.state.currentPage" type="border-card" @tab-click="clickTab" @tab-remove="removeTab">
        <el-tab-pane
          class="homeTab"
          key="home"
          label="首页"
          name="home"
        >
        </el-tab-pane>
        <el-tab-pane
          v-for="(item) in $store.state.cachePagesList"
          :key="item.name"
          :label="item.meta.title"
          closable
          :name="item.name"
        >
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dropdown>
      <span class="avator">
        <el-avatar :size="'large'" src="https://api.goodyiyao.cn/static/upload/other/admin_avatar.jpg"></el-avatar>&emsp; {{user}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item> <div @click="changePw"> 修改密码</div></el-dropdown-item>
        <el-dropdown-item>清除缓存</el-dropdown-item>
        <el-dropdown-item><div @click="logout">退出系统</div></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import FormManagerList from './formManagerList.vue';
import { ManagerService } from '../../service/manager.service';
import { LoginService } from '../../service/login.service';
  export default {
    name: 'userMenu',
    components: { FormManagerList },
    data() {
      return {
        editableTabsValue: false,
        user:JSON.parse(localStorage.getItem('user')).name
      }
    },
    methods: {
      logout() {
        MessageBox.confirm('确定要退出吗？', '退出登入').then(() => {
          LoginService.logout();
        })
      },
      clickTab(component) {
        this.$store.commit({ type: 'setCurrentPage', component: { name: component.name  } });
        // this.$router.push(component.name);
        if (this.$router.currentRoute.name !== component.name) {
          this.$router.push('/' + component.name);
        }
      },
      removeTab(name) {
        this.$store.commit({ type: 'removeCachePage', component: { name } })
      },
      clearAllPages() {
        this.$store.commit({ type: 'clearCachePages' });
        this.$router.push('/home');
      },
      changePw(){
        ManagerService.getManager(JSON.parse(localStorage.getItem('user')).id).then(res=>{
          this.$refs.form.open(res);
        })
      },
      getback(){
        this.$router.push('/login');
      }
    }
  }
</script>

<style lang="scss" scoped>

.homeTab {
  .el-icon-close {
    display: none;
  }
}

.userMenu {
  height: 100%;
  width: 100%;
  display: flex;
}
.tabsBoby {
  width: calc(100% - 150px);
}
.avator {
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.tabs {
  flex: 1;
  display: flex;
  width: 400px;
  align-items: flex-end;
  & .el-tabs {
    flex: 1;
    box-shadow: none;
    border: none;
  }
  & /deep/ .el-tabs__nav-next, .el-tabs__nav-prev {
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 27px;
    height: 27px;
    background: #669cff;
    padding: 2px;
    border-radius: 50%;
    line-height: initial;
    color: #fff;
  }
  & /deep/ .el-tabs__nav-wrap {
    padding: 0 27px;
  }
  & /deep/ .el-tabs__header {
    // border: none;
    background: transparent;
    border: none;
    margin: 0;
  }

  & /deep/ .el-tabs__content {
    display: none;
  }
  & /deep/ .el-tabs__item {
    border-bottom: 1px solid #aaa;
    height: 1.9vw;
    padding-top: 0;
    display: flex;
    align-items: center;
    font-size: 0.8vw;
  }
  & /deep/ .el-tabs__nav {
    display: flex;
  }
  & /deep/ .is-active {
    background-color: #e4ebf2 !important;
    color: #999 !important;
  }
}
.closeIcon {
  font-size: 30px;
  color: #aaa;
  cursor: pointer;
  margin-top: 15px;
  &:hover {
    color: #669cff;
  }
}
</style>

<style lang="scss">
  #app{
    .el-header.header{
      border-bottom: 2px solid #2f4050;
      .el-tabs__item{
        margin-bottom: 1px;
      }
      .el-tabs__item:hover{
        color: #666
      }
      .el-tabs__item.is-active{
        background: #2f4050!important;
        color: #a7b1c2;
      }
      .el-tabs__item.is-active:hover{
        color: #eee!important;
      }
    }
  }
</style>